import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { UserProfile } from '../../../models/Profile'
import ProfileService from '../../../services/ProfileService'
import WorkplaceFooter from '../../common/WorkplaceFooter'
import Protected from '../../Protected'

const Bookmarks = () => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userProfile, setUserProfile] = useState<UserProfile>()
  const { getCurrentUserProfile } = ProfileService

  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchCurrentUserProfile(source)
      .then((profile) => {
        if (mountedRef.current) {
          setUserProfile(profile)
        }
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const fetchCurrentUserProfile = async (source: CancelTokenSource) => {
    return await getCurrentUserProfile(source).then((response) => {
      return response.result
    })
  }
  return (
    <Protected>
      <div className="content-wrapper">
        <article className="main">
          <h1> Bookmarks </h1>

          <p>
            {' '}
            View all the resources you have bookmaked to your account including:
          </p>
          <ul>
            <li>
              <Link to="/my-account/bookmarked-awards">
                awards and award summaries
              </Link>
            </li>
            <li>
              <Link to="/my-account/bookmarked-results">
                pay, leave, shift and notice and redundancy results
              </Link>
            </li>
            <li>
              <Link to="/my-account/bookmarked-pages">
                your favourite pages from our website.
              </Link>
            </li>
          </ul>
        </article>
      </div>
      <p></p>
      <WorkplaceFooter userProfile={userProfile} isLoading={isLoading} />
    </Protected>
  )
}

export default Bookmarks
